import clsx from "clsx";
import type { ComponentProps, ReactNode } from "react";

import { mod } from "@shared/utils";

import { Body } from "../typography";

import s from "./status-badge.module.scss";

export type StatusBadgeProps = ComponentProps<"div"> & {
  className?: string;
  children: ReactNode;
  variant: "open" | "close";
};

export const StatusBadge = (props: StatusBadgeProps) => {
  const { className, children, variant } = props;

  const mods = mod(s, { variant });

  return (
    <Body
      tag="span"
      size="primary"
      weight="semiBold"
      className={clsx(s.root, className, mods)}
    >
      {children}
    </Body>
  );
};

StatusBadge.displayName = "StatusBadge";
